module.exports = __webpack_public_path__ + "img/image_2.697fbb4f.png";